import {
  usePrivateSyncAction,
  UseSyncActionProps,
} from 'modules/integrations/hooks/usePrivateSyncAction'
import { SecondaryActionItem } from '@factorialco/f0-react/dist/experimental'

type UseDataCollectionSyncActionReturn = {
  dataCollectionSyncActions: SecondaryActionItem[]
  syncModal: React.ReactNode | null
}

export const useDataCollectionSyncAction = (
  props: UseSyncActionProps = {}
): UseDataCollectionSyncActionReturn => {
  const { syncActions, syncModal } = usePrivateSyncAction(props)

  return {
    dataCollectionSyncActions: syncActions,
    syncModal,
  }
}
